import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.alerts`;
export const SET_SELECTED_EVENT = `${SCOPE}/SET_SELECTED_EVENT`;
export const TOGGLE_SHOW_ALERTS = `${SCOPE}/TOGGLE_SHOW_ALERTS`;
export const SET_SHARING_STATE = `${SCOPE}/SET_SHARING_STATE`;
export const SET_MATCHING_ALERTS = `${SCOPE}/SET_MATCHING_ALERTS`;
